import api from '../api';

export const createDraft = (data) => {
  return api.post('/company/v2/registration/drafts', data, {
    role: 'company'
  })
}

export const getDraft = (id) => {
  return api.get(`/company/v2/registration/drafts/${id}`, {
    role: 'company'
  })
}

export const updateDraft = (id, data) => {
  return api.patch(`/company/v2/registration/drafts/${id}`, data, {
    role: 'company'
  })
}

export const submitRegistration = (data) => {
  return api.post('/company/v2/registration/submit', data , {
    role: 'company'
  });
};

export const getIndustries = () => {
  return api.get('/company/v2/registration/industries', {
    // Explicitly set the role here
    role: 'company'
  });
};

export const getCompanyIndustryOptions = () => {
  return api.get('/company/v2/registration/industry-options', {
    role: 'company'
  });
};

export const getCompanyMarketCap = (ticker) => {
  return api.get(`/company/v2/registration/asx/${ticker}`, {
    role: 'company'
  });
};


export const getLogoUploadUrl = (draftId, fileType) => {
  return api.post('/company/v2/registration/upload-logo', { draftId, fileType },
    { role: 'company' }
  )
}
